import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=12b78be9&scoped=true"
import script from "./tixian.vue?vue&type=script&lang=js"
export * from "./tixian.vue?vue&type=script&lang=js"
import style0 from "./tixian.vue?vue&type=style&index=0&id=12b78be9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b78be9",
  null
  
)

export default component.exports